<div class="tablet-layout bg-gradient">
  <!-- Region 1: Primary Navigation (Fixed Icon Bar) -->
  <aside class="sidebar-container">
    <app-tablet-sidebar />
  </aside>

  <!-- Main area that contains all scrolling content -->
  <div class="main-area scroll-container" (scroll)="onContentScroll($event)">
    <!-- Bind the visibility class here -->
    <header
      class="header-container bg-surface p-2 sm:p-6 md:p-8 border-b border-border"
      [class.header-hidden]="!headerVisible()"
    >
      <app-main-header [pageTitle]="pageContextService.pageTitle()" />
    </header>

    <!-- Region 3: Page Header (Sticky) -->
    <!-- <div
      class="page-header-container"
      [style.top]="headerVisible() ? '64px' : '0px'"
    >
      @if (pageContextService.pageTitle(); as title) {
      <app-page-header
        [title]="title"
        [subtitle]="pageContextService.pageSubtitle() || undefined"
        [actions]="pageContextService.actions()"
        [primaryAction]="pageContextService.fabAction()"
      />
      }
    </div> -->

    <!-- Region 4: Page Sub-Header (Sticky) -->
    @if (pageContextService.subHeaderContent(); as content) {
    <div
      class="page-sub-header-container bg-gradient"
      [style.top]="headerVisible() ? '64px' : '0px'"
    >
      <div class="sub-header-wrapper">
        @if (isTemplateRef(content)) {
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
        <!-- Otherwise, it's a DynamicComponent, so use ngComponentOutlet -->
        <ng-container
          [ngComponentOutlet]="content.component"
          [ngComponentOutletInputs]="content.inputs"
        >
        </ng-container>
        }
      </div>
    </div>
    }

    <!-- Region 5: Main Content -->
    <main class="main-content-container">
      <app-toast-stack />
      <router-outlet></router-outlet>
      @defer (when featureFlags.aiAssistantEnabled()) {
        <app-assistant-widget />
      }
    </main>
  </div>

  <!-- Region 6: Floating Action Button -->
  <div class="fab-container">
    @if (pageContextService.fabAction(); as action) {
    <app-button
      (click)="pageContextService.emitAction(action.id)"
      [fab]="true"
      [icon]="action?.icon"
    ></app-button>
    }
  </div>

  <!-- Mobile Navigation Menu (Add this section) -->
  <app-mobile-nav-menu
    [isOpen]="layoutService.isMobileMenuOpen()"
    (closed)="layoutService.closeMobileMenu()"
  />
</div>

<!-- ADD: Add the sheet component to handle the aside on tablet -->
<app-sheet
  [isOpen]="!!asideService.asideContext()"
  (closed)="asideService.close()"
  [title]="asideService.asideContext()?.title || 'Details'"
  [headerAction]="asideService.headerAction()"
>
  <app-aside-content></app-aside-content>
</app-sheet>
